import React from "react";
import Constant from "../../Constant";
import Note from "../../Assets/images/note.svg";

// Format transaction date
const formatTxDate = (value) => {
  if (!value) return "N/A";

  const date = new Date(value.replace(" ", "T"));

  if (Number.isNaN(date.getTime())) return "N/A";

  return date.toLocaleDateString("en-GB", {
    day: "numeric",
    month: "short",
    year: "numeric",
  });
};

function ActiveInvestmentTransactionsTab({
  transactions = [],
  loadingTransactions = false,
  error = false,
}) {
  // Loading state
  if (loadingTransactions) {
    return (
      <div role="status" className="flex justify-center my-8">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-[#00BC67]" />
        <span className="sr-only">Loading transactions...</span>
      </div>
    );
  }

  // Error state
  if (error) {
    return (
      <div
        role="alert"
        className="bg-white rounded-[16px] border border-dashed border-gray-200 p-8 text-center my-4"
      >
        <h4 className="text-[#1E222B] font-[700] text-[14px] mb-1">
          Unable to Load Transactions
        </h4>

        <p className="text-[#808285] text-[12px]">
          Something went wrong while fetching your transactions. Please try
          again later.
        </p>
      </div>
    );
  }

  // Empty state
  if (transactions.length === 0) {
    return (
      <div className="bg-white rounded-[16px] border border-dashed border-gray-200 p-8 text-center flex flex-col items-center justify-center my-4">
        <img
          src={Note}
          alt="No transactions"
          className="w-14 h-14 opacity-50 mb-3"
        />

        <h4 className="text-[#1E222B] font-[700] text-[14px] mb-1">
          No Transactions Yet
        </h4>

        <p className="text-[#808285] text-[12px] max-w-xs leading-relaxed">
          Your investment transactions and payment history will appear here.
        </p>
      </div>
    );
  }

  return (
    <div className="border border-gray-100 rounded-xl p-5 shadow-sm space-y-3 bg-white">
      {transactions.map((tx) => {
        const isCredit = tx.transType === "C";
        const isDebit = tx.transType === "D";

        const amount =
          tx.amount != null ? `₦${Constant.FormatNumber(tx.amount)}` : "N/A";

        const amountColor = isCredit
          ? "text-[#00BC67]"
          : isDebit
            ? "text-[#FF3B30]"
            : "text-[#1E222B]";

        const amountPrefix =
          tx.amount == null ? "" : isCredit ? "+" : isDebit ? "-" : "";

        return (
          <div
            key={tx.transactionId}
            className="flex justify-between items-center gap-3 py-3 border-b border-gray-50 last:border-0"
          >
            {/* Transaction Details */}
            <div className="flex-1 min-w-0">
              <p className="text-back-color2 text-[13px] font-bold break-words">
                {tx.description || ""}
              </p>

              <p className="text-[#808285] text-[12px] mt-0.5">
                {formatTxDate(tx.transactionDate)}
              </p>
            </div>

            {/* Transaction Amount */}
            <p
              className={`text-[14px] font-bold whitespace-nowrap flex-shrink-0 ${amountColor}`}
            >
              {amountPrefix}
              {amount}
            </p>
          </div>
        );
      })}
    </div>
  );
}

export default ActiveInvestmentTransactionsTab;
